module.exports = __webpack_public_path__ + "img/horizontal_6_4_8011.39107d44.png";